const ctx = require.context('./', true, /\.api\.js$/)
const apiConfig = {}

ctx.keys().forEach(item => {
    const obj = ctx(item)
    let apis = apiConfig[obj.default.moduleName] || []
    apis = [...apis, ...obj.default.apis]
    apiConfig[obj.default.moduleName] = apis
})

export default apiConfig
